<ng-container *ngrxLet="staticTemplate$ as staticTemplate">
  <ng-container *ngrxLet="dynamicTemplate$ as dynamicTemplate">
    <ng-container *ngrxLet="templateService.currentMode$ as currentMode">
      <div class="dynamic-template">
        <ng-container *ngrxLet="customSlug$ as customSlug">
          @if (customSlug?.isDevelopment) {
          <div class="development-banner">
            Denne side er under udvikling og er ikke endelig
          </div>
          }
        </ng-container>
        <div class="grid-container">
          @if (dynamicOnly) { @for (dynamicComponent of
          filterComponentsByMode(dynamicTemplate, currentMode); track
          trackByComponentUuid(dynamicComponent)) {
          <div
            class="grid-item"
            #gridItem
            [ngStyle]="{
              'grid-column':
                (dynamicComponent?.x || 0) +
                1 +
                ' / span ' +
                (dynamicComponent?.cols || 1),
              'grid-row':
                dynamicComponent.getOrSetInputs()['autoHeight'] &&
                dynamicComponent.getOrSetInputs()['autoHeight'].value
                  ? (dynamicComponent?.y || 0) + 1 + ' / auto'
                  : (dynamicComponent?.y || 0) +
                    1 +
                    ' / span ' +
                    getRowSpan(dynamicComponent, gridItem)
            }"
            [attr.data-auto-height]="
              dynamicComponent.getOrSetInputs()['autoHeight'] &&
              dynamicComponent.getOrSetInputs()['autoHeight'].value
                ? 'true'
                : null
            "
            [id]="
              dynamicComponent.settings && dynamicComponent.settings['customID']
                ? dynamicComponent.settings['customID'].value
                : null
            "
            [class]="
              dynamicComponent.settings &&
              dynamicComponent.settings['customClasses']
                ? dynamicComponent.settings['customClasses'].value
                : null
            "
          >
            @if (isComponentVisible(dynamicComponent)) {
            <app-dynamic-component
              [customComponent]="dynamicComponent"
              [editorMode]="false"
              (afterViewInit)="
                onDynamicComponentInit(gridItem, dynamicComponent)
              "
            >
            </app-dynamic-component>
            }
          </div>
          } } @if (!dynamicOnly) { @for (staticComponent of
          filterComponentsByMode(staticTemplate!, currentMode); track
          trackByComponentUuid(staticComponent)) {
          <div
            class="grid-item"
            [ngStyle]="{
              'grid-column':
                (staticComponent.x || 0) +
                1 +
                ' / span ' +
                (staticComponent.cols || 1),
              'grid-row':
                staticComponent.name === 'MainComponent'
                  ? (staticComponent.y || 0) +
                    1 +
                    ' / span ' +
                    calculateMainComponentSpan(dynamicTemplate, currentMode)
                  : (staticComponent.y || 0) +
                    1 +
                    ' / span ' +
                    (staticComponent.rows || 1)
            }"
            [id]="
              staticComponent.settings && staticComponent.settings['customID']
                ? staticComponent.settings['customID'].value
                : null
            "
            [class]="
              (staticComponent.settings &&
              staticComponent.settings['customClasses']
                ? staticComponent.settings['customClasses'].value
                : '') +
              (staticComponent.name === 'MainComponent'
                ? ' scalable-grid-item-host'
                : '')
            "
            [style]="
              staticComponent.customCSS ? staticComponent.customCSS : null
            "
          >
            @if (staticComponent.name === 'MainComponent') {
            <div class="dynamic-template-container">
              <div class="duna-scale-surface">
                <div class="grid-container" id="main">
                  @for (dynamicComponent of
                  filterComponentsByMode(dynamicTemplate, currentMode); track
                  trackByComponentUuid(dynamicComponent)) {
                  <div
                    class="grid-item"
                    #gridItem
                    [ngStyle]="{
                      'grid-column':
                        (dynamicComponent?.x || 0) +
                        1 +
                        ' / span ' +
                        (dynamicComponent?.cols || 1),
                      'grid-row':
                        dynamicComponent.getOrSetInputs()['autoHeight'] &&
                        dynamicComponent.getOrSetInputs()['autoHeight'].value
                          ? (dynamicComponent?.y || 0) + 1 + ' / auto'
                          : (dynamicComponent?.y || 0) +
                            1 +
                            ' / span ' +
                            getRowSpan(dynamicComponent, gridItem)
                    }"
                    [attr.data-auto-height]="
                      dynamicComponent.getOrSetInputs()['autoHeight'] &&
                      dynamicComponent.getOrSetInputs()['autoHeight'].value
                        ? 'true'
                        : null
                    "
                    [id]="
                      dynamicComponent.settings &&
                      dynamicComponent.settings['customID']
                        ? dynamicComponent.settings['customID'].value
                        : null
                    "
                    [class]="
                      dynamicComponent.settings &&
                      dynamicComponent.settings['customClasses']
                        ? dynamicComponent.settings['customClasses'].value
                        : null
                    "
                  >
                    @if (isComponentVisible(dynamicComponent)) {
                    <app-dynamic-component
                      [customComponent]="dynamicComponent"
                      [editorMode]="false"
                      (afterViewInit)="
                        onDynamicComponentInit(gridItem, dynamicComponent)
                      "
                    >
                    </app-dynamic-component>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
            } @else { @if (isComponentVisible(staticComponent)) {
            <app-dynamic-component
              [customComponent]="staticComponent"
            ></app-dynamic-component>
            } }
          </div>
          } }
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
